import { useEffect, useState } from "react";
import { getRecommendations, generateHealthManual } from "../utils/cancerRecommendations";
import { getHealthScreeningRecommendations } from "../utils/healthScreeningRecommendations";
import ResultPage from "./ResultPage";

// Demo persona: 32F Asian, family history of GI cancer, unhealthy diet, light drinker
const DEMO_SURVEY_DATA = {
  biologicalSex: "female",
  age: 32,
  ethnicity: "asian",
  heightFeet: 5,
  heightInches: 4,
  weight: 135,
  heightUnit: "imperial",
  weightUnit: "imperial",
  bmi: 23.2,
  familyHistory: ["gastrointestinal"],
  chronicDiseases: [],
  smokingStatus: "never",
  packYears: 0,
  secondhandSmoke: "no",
  radiationExposure: "no",
  alcoholDrinks: 2,
  dietHabits: "yes",
};

export default function DemoResultPage() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const surveyData = DEMO_SURVEY_DATA;
    const recommendations = getRecommendations(surveyData, "en");
    const healthManual = generateHealthManual(surveyData, "en");
    const healthScreening = getHealthScreeningRecommendations(surveyData);

    localStorage.setItem(
      "omnicare_analysis_results",
      JSON.stringify({ surveyData, recommendations, healthManual, healthScreening })
    );
    setReady(true);
  }, []);

  if (!ready) return null;
  return <ResultPage />;
}
